// Copyright 2026, Imprivata, Inc.  All rights reserved.

import type { IdvAuthMethod, IdvIalLevel } from '../../../api/types';

export const TRANSLATION_ROOT = 'portal.settings.idv-connections';

export enum FieldName {
  DISPLAY_NAME = 'displayName',
  REDIRECT_URIS = 'redirectUris',
  JWKS_URI = 'jwksUri',
  AUTH_METHOD = 'authMethod',
  SCOPES = 'scopes',
  IAL_LEVEL = 'ialLevel',
}

export interface FormValues {
  [FieldName.DISPLAY_NAME]: string;
  [FieldName.REDIRECT_URIS]: string[];
  [FieldName.JWKS_URI]?: string;
  [FieldName.AUTH_METHOD]?: IdvAuthMethod;
  // Optional scopes selected in the form. Typed as `string[]` (not the `IdvScope` enum)
  // because the options come from the tenant's discovery doc, which may advertise scopes
  // beyond the ones we ship copy for (e.g. `address`).
  [FieldName.SCOPES]?: string[];
  [FieldName.IAL_LEVEL]?: IdvIalLevel;
}
